import { Injectable } from "@angular/core";
import { IFacebookAnalyticsConfig } from '@signature-it/ngx-generic/interfaces';
import { AbstractTracker } from '@signature-it/ngx-generic/classes';

declare let fbq: any;

@Injectable({
    providedIn: 'root'
})
export class FacebookAnalyticsService extends AbstractTracker {
    readonly ATTR_TRACKER_NAME: string = "facebookAnalytics";

    protected _config: IFacebookAnalyticsConfig;

    /**
     * @whatItDoes Add Google Analytics script to <body>
     * @param IFacebookAnalyticsConfig config
     */
    create(config: IFacebookAnalyticsConfig) {
        this._config = config;
        this._appendScripts(document.head);
        return this;
    }

    protected _sendPageView(path: string): void {
        if(typeof fbq !== "undefined") {
            fbq('track', 'PageView');
        } else {
            console.log("fbq function isn't defined. Facebook Pixel doesn't triggered pageviews");
        }
    }

    _sendEvent(eventName: string, data: any = null): void {
        if(typeof fbq !== "undefined") {
            fbq('track', eventName, data);
        } else {
            console.log("fbq function isn't defined. Facebook Pixel doesn't triggered pageviews");
        }
    }

    protected _appendScripts(whereEl: HTMLElement): void {
        if (this._hasTrackingId()) {
            const script = document.createElement('script');
            script.text = `!function(f,b,e,v,n,t,s)
                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window, document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');
                  fbq('init', '${this._config.tracking_id}');`;
            whereEl.appendChild(script);
        }
    }

}
